import React from 'react'
import styled from 'styled-components'
import C3Mark from '../elements/C3Mark'

const StyledFooter = styled.footer`
  background-color: ${(props) => props.theme.color.main};
`

// The divider underneath runs the full width of the viewport.
const Bar = styled.div`
  border-bottom: 1px solid rgba(255, 255, 255, 0.85);

  & > .container {
    display: flex;
    align-items: center;
  }

  @media (min-width: 992px) {
    padding-block: 45px;
  }

  @media (max-width: 991.98px) {
    padding-block: 25px;
  }
`

const Payoff = styled.span`
  color: #d50021;
  font-style: italic;
  font-weight: 400;
  text-transform: uppercase;

  @media (min-width: 992px) {
    font-size: 30px;
    margin-left: 65px;
  }

  @media (max-width: 991.98px) {
    font-size: 20px;
    margin-left: 30px;
  }
`

const Bottom = styled.div`
  @media (min-width: 992px) {
    height: 38px;
  }

  @media (max-width: 991.98px) {
    height: 35px;
  }
`

function FooterLanding() {
  return (
    <StyledFooter>
      <Bar>
        <div className="container">
          <C3Mark width={28} height={46} />
          <Payoff>Baanbrekend bouwen</Payoff>
        </div>
      </Bar>
      <Bottom />
    </StyledFooter>
  )
}

export default FooterLanding
